import { useContext } from 'react';
import { ViewerContext } from 'dash-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BrokerPortfolioTypesEnum } from 'dash-common';

import { PortfolioListItemFragment } from 'gql/generated.graphql';
import { RoutesPath } from 'flow-components/routes/routes';
import { getPreviewPortfolioPropertyLink } from 'common/helpers/portfolio';

import PortfolioCardItem from './components/PortfolioCardItem/PortfolioCardItem';
import { StyledList } from './PortfoliosListCardView.styles';

const PortfoliosListCardView = ({
  portfolios,
  loading,
}: {
  portfolios: PortfolioListItemFragment[];
  loading: boolean;
}) => {
  const theme = useTheme();
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { broker, profile } = useContext(ViewerContext);

  return (
    <StyledList
      listProps={{
        data: portfolios,
        flexWrap: 'wrap',
        gap: [12, 12, 20, 20],
        grid: [343, 254, 356, 356],
        loading,
        // min height in case if there no data and loading in progress, we need to avoid loading collapse over headers
        minHeight: 150,
        loadingProps: {
          bgColor: portfolios.length ? theme.colors.n20 : 'inherit',
        },
      }}
      paginationProps={{
        nextButtonLabel: t('common:labels.next'),
        previousButtonLabel: t('common:labels.previous'),
      }}
    >
      {(portfolio) => (
        <PortfolioCardItem
          onClick={() => {
            const isFolder = portfolio.type === BrokerPortfolioTypesEnum.FOLDER;
            if (isFolder) {
              return navigate(
                RoutesPath.PortfolioDetails.replace(':id', portfolio._id)
              );
            }
            window?.open(
              getPreviewPortfolioPropertyLink(portfolio, broker, profile),
              '_blank'
            );
          }}
          portfolio={portfolio}
        />
      )}
    </StyledList>
  );
};

export default PortfoliosListCardView;
